import { STATUS_CONFIG } from "../statusConfig";

export function StatusBadge({ status, dataTestId }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.unknown;
  const Icon = cfg.Icon;
  return (
    <span
      data-testid={dataTestId}
      className={"inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-sm " + cfg.badgeClass}
    >
      <Icon size={11} className={cfg.badgeIconClass} strokeWidth={2} />
      {cfg.label}
    </span>
  );
}
